import React from 'react';
import { Typography, Box, Stack } from '@mui/material';
import { CheckCircle } from '@mui/icons-material';
import { FEATURES } from '../constants';

const FeaturesList = () => {
  return (
    <Box
      sx={{
        bgcolor: '#f8fafc',
        borderRadius: 3,
        p: 4,
        mb: 6,
        textAlign: { xs: 'left', md: 'center' },
      }}
    >
      <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 3, color: '#1e293b' }}>
        Included with every plan
      </Typography>
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        spacing={{ xs: 2, md: 4 }}
        justifyContent={{ xs: 'flex-start', md: 'center' }}
        alignItems={{ xs: 'flex-start', md: 'center' }}
      >
        {FEATURES.map((text, idx) => (
          <Stack key={idx} direction="row" spacing={1} alignItems="center">
            <CheckCircle sx={{ fontSize: 20, color: '#47e5c0' }} />
            <Typography variant="body1">{text}</Typography>
          </Stack>
        ))}
      </Stack>
    </Box>
  );
};

export default FeaturesList;
